//Single variable used to change text of the username/email label and alternate email/username label in most locations
export const loginLabel = 'Username';
export const emailLoginLabel = 'Email';
export const loginLabelLower = loginLabel.toLowerCase();

export const loginHelper = loginLabel + ' format';

export const updatedLoginLabel = 'Email or Username';
export const updatedLoginLabelLowercase = updatedLoginLabel.toLowerCase();
